import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyLeafCollectionManualReport } from './Pages';

export const DailyLeafCollectionManualReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={DailyLeafCollectionManualReport} />
    </Fragment>
)